import { fetchCart, fetchUser } from "../utils/fetchLocalStorageData";
const userInfo=fetchUser()


export const initialState = {
    user: userInfo,
    Products:null,
    Company:null,
    Blog:[],
    Slider:null,
    appliedJobs:[],
   Service:[],
};


  